"use client";

import { ContentfulLivePreview } from "@contentful/live-preview";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";

import SymbolizedElement from "shared-components/components/SymbolizedElement";

export default function RecipeTitle({ recipe }: { recipe: Recipe }) {
  const updateRecipe = useContentfulLiveUpdates(recipe);
  return (
    <h1
      {...ContentfulLivePreview.getProps({
        entryId: recipe?.sys.id,
        fieldId: "title",
      })}
    >
      <SymbolizedElement
        title={updateRecipe?.title}
        className="text-2xl font-bold md:text-4xl"
      />
    </h1>
  );
}
